import React from 'react'

interface FloatingButtonCirclesProps {
  variant?: 'default' | 'green' | 'yellow'
  className?: string
  position?: 'left' | 'right'
}

export function FloatingButtonCircles(
  { 
    variant = 'default',
    className = '',
    position = 'left'
  }: FloatingButtonCirclesProps) {
  const getVariantClasses = () => {
    switch (variant) {
      case 'green':
        return 'from-emerald-500 to-emerald-600'
      case 'yellow':
        return 'from-amber-500 to-amber-600'
      default:
        return 'from-gray-400 to-gray-700'
    }
  }

  const gradientClasses = getVariantClasses()
  const isActive = variant !== 'default'

  const boxes = [
    {
      activeWidth: 48,
      inactiveWidth: 38,
      activeOpacity: 0.15,
      inactiveOpacity: 0,
      duration: 1000,
      delay: 0,
      showOnlyWhenActive: true
    },
    {
      activeWidth: 58,
      inactiveWidth: 48,
      activeOpacity: 0.12,
      inactiveOpacity: 0.16,
      duration: 800,
      delay: 100
    },
    {
      activeWidth: 68,
      inactiveWidth: 58,
      activeOpacity: 0.09,
      inactiveOpacity: 0.12,
      duration: 900,
      delay: 200
    },
    {
      activeWidth: 78,
      inactiveWidth: 68,
      activeOpacity: 0.06,
      inactiveOpacity: 0.04,
      duration: 1000,
      delay: 300
    }
  ]

  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      {boxes.map((box, index) => {
        if (box.showOnlyWhenActive && !isActive) return null

        const width = isActive ? box.activeWidth : box.inactiveWidth
        const opacity = isActive ? box.activeOpacity : box.inactiveOpacity

        return (
          <div
            className={`absolute ${position === 'left' ? 'left-0' : 'right-0'} top-0 bottom-0 bg-gradient-to-b ${gradientClasses}
              transition-all ease-out`}
            key={index}
            style={{
              borderRadius: position === 'left' ? '6px 20px 20px 6px' : '20px 6px 6px 20px',
              transitionDelay: `${box.delay}ms`,
              transitionDuration: `${box.duration}ms`,
              opacity,
              width: `${width}px`
            }}
          />
        )
      })}
    </div>
  )
}
